<template>
  <div class="table-page-search-wrapper">

  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'PaperSearchForm',
  mounted () {

  },
  computed: {
    ...mapState({

    })
  },
  data () {
    return {
      layout: 'inline',
      gutter: 48,
      spanMd: 6,
      spanSm: 24,
      showExpend: true,

      searchModel: {
      },
      advanced: false// 是否展开
    }
  },
  methods: {

    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      for (var key in this.searchModel) {
        if (this.searchModel[key] === undefined || this.searchModel[key] === null || this.searchModel[key] === '') {
          delete this.searchModel[key]
        }
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.$emit('clearSearch', this.searchModel)
    }
    // 获取select列表

  }
}
</script>

<style scoped lang="less">

</style>
